<template>
  <div id="app">
    <div class="body_bg">
      <div class="container pd15 whitebg">
        <el-row :gutter="25">
          <el-col
            :xs="24"
            :sm="24"
            :md="19"
            :lg="19"
            :xl="19"
            class="rightfloat"
          >
            <div class="grid-content bg-purple-light">
              <div class="side_con">
                <div class="title_all" style="margin-bottom: 0">
                  <div class="title_left">收录情况</div>
                  <div class="title_more2"><a href="">首页</a>>收录情况</div>
                  <div class="clearfix"></div>
                </div>
                <div class="side_container">
                  <div>
                    《{{
                      $store.state.Name
                    }}》
                  </div>
                </div>
              </div>
            </div>
          </el-col>
          <common-sidebar></common-sidebar>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      keywords: '',
      activeName: 'first',
    }
  },
  components: {},
  methods: {},
}
</script>

<style scoped></style>
